export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_USERS_LOADING = 'GET_ALL_USERS_LOADING';
export const GET_USER = 'GET_USER';
export const EDIT_USER = 'EDIT_USER';
export const ADD_USER = 'ADD_USER';
export const IS_PRINCIPAL_NAME_AVAILABLE = 'IS_PRINCIPAL_NAME_AVAILABLE';
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';
export const USERS_COUNT = 'USERS_COUNT';
export const EXPIRE_USER_PASSWORD = 'EXPIRE_USER_PASSWORD';
export const REMOVE_EXPIRE_USER_PASSWORD_RESPONSE = 'REMOVE_EXPIRE_USER_PASSWORD_RESPONSE';
export const REMOVE_ROLE_MEMBERSHIP = 'REMOVE_ROLE_MEMBERSHIP';
export const IMPORT_USERS = 'IMPORT_USERS';
export const REMOVE_GROUP_MEMBERSHIP = 'REMOVE_GROUP_MEMBERSHIP';
export const REVOKE_PUSH = 'REVOKE_PUSH';
export const REVOKE_U2F = 'REVOKE_U2F';
export const REVOKE_OTP = 'REVOKE_OTP';
export const IMPORT_USERS_ERROR = 'IMPORT_USERS_ERROR';
export const UPDATE_USER_ATTRIBUTE = 'UPDATE_USER_ATTRIBUTE';
export const UPDATE_USER_ATTRIBUTES = 'UPDATE_USER_ATTRIBUTES';
export const ADD_USER_ATTRIBUTE = 'ADD_USER_ATTRIBUTE';
export const DELETE_USER_ATTRIBUTE = 'DELETE_USER_ATTRIBUTE';
export const UPDATE_USER_ATTRIBUTE_RESET = 'UPDATE_USER_ATTRIBUTE_RESET';
export const PATCH_USER = 'PATCH_USER';
export const SET_USER_APNS = 'SET_USER_APNS';
export const SET_USER_PATCH_DATA = 'SET_USER_PATCH_DATA';
export const ADD_ROLES_MEMBERSHIP = 'ADD_ROLES_MEMBERSHIP';
export const ADD_GROUPS_MEMBERSHIP = 'ADD_GROUPS_MEMBERSHIP';